<form #form="ngForm">
    <span>{{adultIncomeSubType.Name | translate}}</span><span *ngIf="showMilitaryAdditionalText" translate> (made available to the household)</span>
    <mat-chip-list id="adultIncomeSubQuestionsChipList{{localId}}" style="padding-bottom: 15px;">
        <mat-chip id="adultIncomeSubQuestionsYes{{localId}}" [selected]='adultHasIncome() == true' (click)="adultHasIncomeClick(true)"><span translate>Yes</span></mat-chip>
        <mat-chip id="adultIncomeSubQuestionsNo{{localId}}" [selected]='adultHasIncome() == false' (click)="adultHasIncomeClick(false)"><span translate>No</span></mat-chip>
    </mat-chip-list>
    <ng-container *ngFor="let ai of adultIncome; let i = index">
        <div style="display:flex; flex-direction: column;">
            <div style="display:flex; align-items: flex-start;">
                <frma-currency-input [(amount)]="ai.Amount"></frma-currency-input>
                <tyl-form-field label='Frequency' style="width: 170px;margin-right: 20px;">
                    <mat-select #ddlFrequency id='ddlFrequency{{i}}-{{localId}}' [(ngModel)]='ai.Frequency' name='Frequency{{i}}-{{localId}}' required>
                        <mat-option value='yearly' *ngIf="adultIncomeSubType.ID == 1 || adultIncomeSubType.ID == 4 || adultIncomeSubType.ID == 8"><span translate>Yearly</span></mat-option>
                        <mat-option value='monthly'><span translate>Monthly</span></mat-option>
                        <mat-option value='twice per month'><span translate>Twice per month</span></mat-option>
                        <mat-option value='every two weeks'><span translate>Every two weeks</span></mat-option>
                        <mat-option value='weekly'><span translate>Weekly</span></mat-option>
                        <mat-option value='hourly'*ngIf="adultIncomeSubType.ID == 4"><span translate>Hourly</span></mat-option>
                    </mat-select>
                </tyl-form-field>
                <button mat-stroked-button (click)="removeClick(ai)" class="button" type="button" *ngIf="adultIncome.length > 1" style="margin-top: 5px;">
                    Remove
                </button>
            </div>
            <div *ngIf="ai.Frequency == 'hourly'" style="display: flex;">
                <tyl-form-field label='Hours' style="width: 170px;margin-right: 20px;">
                    <input #txtHours matInput id='inpHours{{i}}-{{localId}}' numbers-only [allowDecimal]='true' name='Hours{{i}}-{{localId}}' type='text' [(ngModel)]='ai.Hours' required/>
                </tyl-form-field>
                <tyl-form-field label='Per' style="width: 170px;">
                    <mat-select #ddlPer id='ddlPer{{i}}-{{localId}}' [(ngModel)]='ai.Per' name='Per{{i}}-{{localId}}' required>
                        <mat-option value='Week'><span translate>Week</span></mat-option>
                        <mat-option value='Month'><span translate>Month</span></mat-option>
                    </mat-select>
                </tyl-form-field>
            </div>                     
        </div>
    </ng-container>
    <button mat-stroked-button (click)="addAdultIncome()" class="button" type="button" style="width: 170px;margin-bottom: 10px;" *ngIf="adultIncome.length > 0">
        Add Income Source
    </button>
</form>